export enum InputType {
  TEXT = "text",
  SEARCH = "search",
  NUMBER = "number",
}

export enum InputVariant {
  DEFAULT = "default",
  ELEVATED = "elevated",
}

export enum InputSize {
  SMALL = "small",
  MEDIUM = "medium",
}

export interface InputEmits {
  (e: "focus", event: FocusEvent): void;
  (e: "blur", event: Event): void;
  (e: "clear"): void;
}

export interface InputProps {
  id: string;
  isDisabled?: boolean;
  type: InputType;
  label?: string;
  size?: InputSize;
  hasClear?: boolean;
  autocomplete?: string;
  spellcheck?: "true" | "false";
  hasError?: boolean;
  variant?: InputVariant;
  autoFocus?: boolean;
  selectOnFocus?: boolean;
}
